import { render, staticRenderFns } from "./companyBasic.vue?vue&type=template&id=01371654&scoped=true&"
import script from "./companyBasic.vue?vue&type=script&lang=js&"
export * from "./companyBasic.vue?vue&type=script&lang=js&"
import style0 from "./companyBasic.vue?vue&type=style&index=0&id=01371654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01371654",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01371654')) {
      api.createRecord('01371654', component.options)
    } else {
      api.reload('01371654', component.options)
    }
    module.hot.accept("./companyBasic.vue?vue&type=template&id=01371654&scoped=true&", function () {
      api.rerender('01371654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/pageUICustom/companyBasic.vue"
export default component.exports